import React from "react";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { Link } from "react-router-dom";
import withPermissions from "../../components/WithPermissions";
import ReceivableSupplierTable from "../../components/Tables/ReceivableSupplierTable";
import ManagementPageHero from "../../components/ManagementPageHero";

class Receivables extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {userPermissions} = this.props;
    const userHasNewReceivablePermission = userPermissions.includes('new receivable');
    return (
      <div
        className="management-page"
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Cari Hareketler"
                Breadcrumb={[
                  {name: "Tedarikçi Cari Hareketleri", navigate: ""},

                ]}
            />
            <ManagementPageHero
              eyebrow="TEDARİKÇİ CARİLERİ"
              title="Tedarikçi hesaplarını yönetin"
              description="Tedarikçi borç, alacak ve ödeme hareketlerini güncel bakiyeleriyle birlikte izleyin."
              actionTo={userHasNewReceivablePermission ? "/receivable-supplier-add" : null}
              actionLabel="Yeni cari hareket"
            />
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <div className="card planned_task management-list-card">
                  <div className="header">
                    <h2>Tedarikçi Cari Hareketleri</h2>
                    {userHasNewReceivablePermission ? (
                        <Dropdown as="ul" className="header-dropdown">
                          <Dropdown.Toggle
                              variant="success"
                              as="li"
                              id="dropdown-basic"
                          >
                            <i className="icon-plus text-success p-1 ml-1"></i>
                            <Dropdown.Menu
                                as="ul"
                                className="dropdown-menu dropdown-menu-right"
                            >
                              <li>
                                <Link to="/receivable-supplier-add">Yeni Alacak/Borç</Link>
                              </li>

                            </Dropdown.Menu>
                          </Dropdown.Toggle>
                        </Dropdown>
                    ) : ""}

                  </div>
                  <div className="body">
                    <ReceivableSupplierTable>

                    </ReceivableSupplierTable>
                  </div>
                </div>
              </div>
            </div>
            <style>
              {`
                  #dropdown-basic::after {
                      display: none;                                                     
                  }
                `}
            </style>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ioTReducer}) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(connect(mapStateToProps, {})(Receivables));
